export default {
    'linking-materials-to-specializations': 'ربط المواد بالتخصصات',
    'add-new-specialty': 'إضافة تخصص جديد',
    'this-specialty': 'هذا التخصص',
    'edit-specialty': 'تعديل التخصص'
}